import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconDeliveryTruck';
/** Renders an SVG icon. */
const SvgDeliveryTruck = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 9a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v13a1 1 0 1 1-2 0V9a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h2a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3zm10.293 2.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L14.586 15l-2.293-2.293a1 1 0 0 1 0-1.414M12 25a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20 9a1 1 0 0 1 1-1h2.84a3 3 0 0 1 2.604 1.512l3.16 5.53a3 3 0 0 1 .396 1.49V23a3 3 0 0 1-3 3h-2a1 1 0 1 1 0-2h2a1 1 0 0 0 1-1v-5h-7a1 1 0 1 1 0-2h6.848l-3.14-5.496a1 1 0 0 0-.869-.504H21a1 1 0 0 1-1-1M10 23a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M22 23a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
      />
      <path
        fill="currentColor"
        d="M8.592 15.707a1 1 0 0 1 0-1.414l.707-.707a1 1 0 0 1 1.414 0l.708.707a1 1 0 0 1 0 1.414l-.708.707a1 1 0 0 1-1.414 0z"
      />
    </svg>
  );
};
SvgDeliveryTruck.displayName = displayName;
export default SvgDeliveryTruck;
